var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.667,
    y: 2.667,
    width: 28,
    height: 26.667,
    rx: 6,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_15134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.105 0H2.895A2.895 2.895 0 0 0 0 2.895v26.21A2.895 2.895 0 0 0 2.894 32h26.211A2.895 2.895 0 0 0 32 29.105V2.895A2.895 2.895 0 0 0 29.105 0zM9.902 27.63a.842.842 0 0 1-.842.843H5.474a.842.842 0 0 1-.843-.842V12.599c0-.465.377-.842.843-.842H9.06c.465 0 .842.377.842.842v15.032zM7.267 10.34a3.407 3.407 0 1 1 0-6.813 3.407 3.407 0 0 1 0 6.813zM28.64 27.699a.775.775 0 0 1-.774.774h-3.848a.775.775 0 0 1-.774-.774v-7.051c0-1.052.308-4.609-2.75-4.609-2.37 0-2.852 2.435-2.948 3.527V27.7a.774.774 0 0 1-.775.774h-3.721a.775.775 0 0 1-.775-.774V12.53c0-.427.347-.774.775-.774h3.721c.428 0 .775.347.775.774v1.312c.88-1.32 2.186-2.338 4.968-2.338 6.162 0 6.126 5.756 6.126 8.919v7.275z",
    fill: "#2E64BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_15134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#fff"
  })))));
};
export default SvgLinkedin;